// extracted by mini-css-extract-plugin
module.exports = {"servicesContainer":"Services_servicesContainer__tgVfX","tag":"Services_tag__THSyA","limitedHeight":"Services_limitedHeight__re3qL","normalHeight":"Services_normalHeight__qYGJ_"};